import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="py-16 border-t border-border/50"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="font-heading text-2xl font-semibold tracking-tight text-foreground">
              Cita Rush
            </Link>
            <p className="text-sm text-muted-foreground mt-3 leading-relaxed max-w-xs">
              Premium offline dating experiences in Pune. Curated singles nights at partner venues.
            </p>
            <p className="text-sm text-muted-foreground mt-2">
              Pune, Maharashtra
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-mono text-xs tracking-[0.2em] uppercase font-semibold text-muted-foreground mb-4">
              Navigate
            </h4>
            <ul className="space-y-2">
              {[
                { label: "How it works", href: "/#how-it-works" },
                { label: "Events", href: "/#events" },
                { label: "Pricing", href: "/#pricing" },
                { label: "FAQ", href: "/#faq" },
                { label: "For venues", href: "/#venues" },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-mono text-xs tracking-[0.2em] uppercase font-semibold text-muted-foreground mb-4">
              Legal
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-terms-link">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-privacy-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-refund-link">
                  Refund / No-Match Policy
                </Link>
              </li>
              <li>
                <Link to="/code-of-conduct" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-conduct-link">
                  Code of Conduct
                </Link>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-mono text-xs tracking-[0.2em] uppercase font-semibold text-muted-foreground mb-4">
              Connect
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Instagram
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Twitter / X
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border/50 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} Cita Rush. All rights reserved. 18+ only.
          </p>
          <p className="text-xs text-muted-foreground">
            All guests must respect the{" "}
            <Link to="/code-of-conduct" className="underline underline-offset-2 hover:text-foreground transition-colors">
              code of conduct
            </Link>.
          </p>
        </div>
      </div>
    </footer>
  );
}
